import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { RouteErrorHandler } from '@/shared/components/route-error-handler';
import { createRoute } from '@tanstack/react-router';

export const fleetRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'fleet',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Fleet')),
  errorComponent: ({ error, reset }) => {
    return <RouteErrorHandler error={error} reset={reset} routeName="fleet" />;
  },
});
